// components
import MNPG from "./MNPG";
// types
import { TMainPageLayoutV3 } from "../type";
import useContent from "@/hooks/useContent";
import { isEmpty } from "lodash";


const MNPG071 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG071.rendered: ", props);

    const unqKey = props.template?.id?.split("-")[4];

    const contentDetails = useContent({unqKey:`${unqKey}CD`, id:props.template?.contentId||""});

    console.log("MNPG071.rendered.1: ", unqKey, contentDetails);

    if ( !props.template || isEmpty(props.template) || !contentDetails || isEmpty(contentDetails) ) return null;

    return (
        <MNPG templates={props.templates} mapLayoutName={props.template.mapLayoutName} parentId={props.template.id} params={{contentDetails}} />
    )
}

export default MNPG071;
